import React, { useContext } from 'react';
import { Navigate, Route, Routes, Outlet } from 'react-router-dom';
import Page404 from './Page404';
import UserRegistration,{UserRegistrationStatus} from '../components/public/UserRegistration';
import UserProfilePage from '../components/Section/Contents/User/UserProfile';
import Login from '../components/Login/Login';
import Main from './Main';
import AdminUsers from '../components/Section/pages/AdminUsers';
import PaymentResponse from '../components/Section/pages/PaymentResponse.js';
import MemberUpdates from '../components/Section/pages/MemberUpdates';
import Transactions from '../components/Section/pages/Transactions';
import PurchaseHistory from '../components/Section/pages/PurchaseHistory';
import Members from '../components/Section/pages/Members';
import Statistics from '../components/Section/pages/Statistics';
import User from '../components/Section/pages/User';
import PrivateRoute from './PrivateRoute/PrivateRoute';
import StatisticsReport from '../components/Section/pages/St-ReportBar/StatisticsReport';
import Logs from '../components/Section/pages/Logs';
import Settings from '../components/Section/pages/Settings';
import SetPayment from '../components/Section/pages/SetPayment';
import Home from '../components/home/Home';
import Verification from '../components/Section/pages/Verification';
import Approve from '../components/Section/pages/Approve';
import { ContextData } from '../context/Context';
import Pending from '../components/Section/pages/Pending';
import IDCard from '../components/Section/pages/ID-Card';
import SetCommission from '../components/Section/pages/SetCommission';
import Pay from '../components/Section/pages/Pay';
import PrentableDisc from '../components/Section/pages/PrentableDisc';
import PrentablePage from '../components/Section/pages/PrentablePage';

function RequireRoles({ roles, userType }) {
  const { Person } = useContext(ContextData);
  return roles.includes(String(Person?.acc_level)) && (!userType || Person?.usertype === userType)
    ? <Outlet /> : <Navigate to="/dashboard/members" replace />;
}

export default function Router() {
  return <Routes>
    <Route element={<PrivateRoute />}>
      <Route path="/dashboard" element={<Main />}>
        <Route index element={<Navigate to="members" replace />} />
        <Route element={<RequireRoles roles={['100']} />}>
          <Route path="transactions" element={<Transactions />} />
          <Route path="payment" element={<SetPayment />} />
          <Route path="adminusers" element={<AdminUsers />} />
          <Route path="user" element={<User />} />
          <Route path="statistics" element={<Statistics />} />
          <Route path="report_statistics" element={<StatisticsReport />} />
          <Route path="logs" element={<Logs />} />
          <Route path="commission" element={<SetCommission />} />
          <Route path="pay" element={<Pay />} />
        </Route>
        <Route element={<RequireRoles roles={['100', '90']} />}>
          <Route path="updates" element={<MemberUpdates />} />
          <Route path="verification" element={<Verification />} />
          <Route path="approve" element={<Approve />} />
          <Route path="pending" element={<Pending />} />
          <Route path="id_card" element={<IDCard />} />
          <Route path="prentable_disc" element={<PrentableDisc />} />
        </Route>
        <Route element={<RequireRoles roles={['0']} userType="user" />}>
          <Route path="purchase-history" element={<PurchaseHistory />} />
          <Route path="payment-response/:reference" element={<PaymentResponse />} />
        </Route>
        <Route path="profile" element={<UserProfilePage />} />
        <Route path="settings" element={<Settings />} />
        <Route path="members" element={<Members />} />
      </Route>
      <Route element={<RequireRoles roles={['100', '90', '40']} />}>
        <Route path="/prentable-page/:token1/:token2" element={<PrentablePage />} />
      </Route>
    </Route>
    <Route path="/register-user" element={<UserRegistration />} />
    <Route path="/register-user/status/:reference" element={<UserRegistrationStatus />} />
    <Route path="/home" element={<Home />} />
    <Route index element={<Navigate to="/home" replace />} />
    <Route path="/404" element={<Page404 />} />
    <Route path="/login" element={<Login />} />
    <Route path="*" element={<Navigate to="/404" replace />} />
  </Routes>;
}
